import { render, staticRenderFns } from "./ChannelsSMS.vue?vue&type=template&id=51b53738"
import script from "./ChannelsSMS.vue?vue&type=script&lang=js"
export * from "./ChannelsSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports